<template>
  <div>
    <p class="subtitle">
      <span v-if="paymentTotal">
        Your difference total is <strong>{{ paymentTotal | currency }}</strong>.
      </span>
      <span> Please select your preferred payment method below</span>
    </p>
    <ul class="payment-method-list">
      <li
        class="payment-method"
        :class="paymentMethod === 'creditcard' && 'selected'"
        @click="selectMethod('creditcard')"
      >
        <img :src="CreditCardLogo">
        <span>Credit or debit card</span>
      </li>
      <li class="credit-card-details">
        <CreditCardMethod
          v-if="paymentMethod === 'creditcard'"
          :selected-card="selectedCard"
          @selectCard="selectCard"
        />
      </li>
      <li
        class="payment-method"
        :class="paymentMethod === 'paypal' && 'selected'"
        @click="selectMethod('paypal')"
      >
        <img :src="PayPalLogo">
        <span>PayPal</span>
      </li>
      <li
        v-if="userHasCredits()"
        class="payment-method"
        :class="paymentMethod === 'credit' && 'selected'"
        @click="selectMethod('credit')"
      >
        <img
          :src="TacoLogo"
          class="taco-fill"
        >
        <span>AppSumo Credits</span>
      </li>
      <!--
      <li
        class="payment-method"
        :class="paymentMethod === 'applepay' && 'selected'"
        @click="selectMethod('applepay')"
      >
        <ApplePayLogo />
        <span>Apple Pay</span>
      </li>
      <li
        class="payment-method"
        :class="paymentMethod === 'googlepay' && 'selected'"
        @click="selectMethod('googlepay')"
      >
        <GooglePayLogo />
        <span>Google Pay</span>
      </li>
      -->
    </ul>
  </div>
</template>

<script>
import CreditCardLogo from '../../../public/creditcard.svg';
import PayPalLogo from '../../../public/paypal.svg';
import TacoLogo from '../../../public/as-taco.svg';
// import ApplePayLogo from '../../../public/applepay.svg';
// import GooglePayLogo from '../../../public/googlepay.svg';
import CreditCardMethod from './CreditCardMethod.vue';

export default {
  name: 'SelectPaymentMethod',
  components: {
    CreditCardMethod,
  },
  filters: {
    // TODO: make global filter
    currency(value) {
      const money = parseFloat(value);
      const cents = (money % 1.0);
      if (cents > 0) {
        return `$${money.toFixed(2)}`;
      }

      return `$${money}`;
    },
  },
  props: {
    paymentMethod: {
      type: String,
      default: '',
    },
    selectedCard: {
      type: Object,
      default: () => ({}),
    },
    paymentTotal: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return ({
      CreditCardLogo,
      PayPalLogo,
      TacoLogo,
    // ApplePayLogo,
    // GooglePayLogo,
    });
  },
  created() {
    if (!this.paymentMethod) {
      this.$emit('selectMethod', 'creditcard');
    }
  },
  methods: {
    selectMethod(method) {
      this.$emit('selectMethod', method);
    },
    selectCard(card) {
      this.$emit('selectCard', card);
    },
    userHasCredits() {
      const credits = parseFloat(document.getElementById('user-credit-amount').value);
      const total = parseFloat(this.paymentTotal);

      if (credits >= total) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../variables.scss";

.subtitle {
  font-size: 14px;
  font-weight: 500;
  margin: 20px 0px 10px;
}

.credit-card-details {
  order: 99;
  width: 100%;
}

.payment-method-list {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  flex-flow: row wrap;
}

.taco-fill {
  fill: $warning-color;
}

//TODO: This is the same as the other card styles used in related components
// We should either factor this our into a UI component or make base style in Sass
.payment-method {
  border: 1px solid #e5e5e9;
  border-radius: 3px;
  color: $primary-color;
  font-weight: 600;
  padding: 15px 10px;
  margin: 15px 15px 0px 0px;
  cursor: pointer;
  width: 270px;
  display: flex;
  align-items: center;

  img {
    vertical-align: middle;
    height: 24px;
    margin-right: 5px;
  }

  &.selected {
    border: 1px solid $primary-color;
    background: rgba($primary-color, 0.05);
  }
}

@media screen and (max-width: $license-modal-mobile) {
  .payment-method-list  {
    flex-flow: column nowrap;
  }
  .payment-method {
    width: auto;
    font-size: 12px;
    padding: 10px 5px;
  }
  .credit-card-details {
    order: initial;
    padding-left: 20px;
  }
}
</style>
